module.exports = __webpack_public_path__ + "static/gold_dragon_treasure-74eabc0be7ce1e4eb0b0a0b03089e94a.jpg";